export const UPDATE_AUTH_STATUS = 'UPDATE_AUTH_STATUS';
export const SET_SESSION_LOADING_STATUS = 'SET_SESSION_LOADING_STATUS';

export const updateAuthStatus = isAuthenticated => ({
  type: UPDATE_AUTH_STATUS,
  data: { authenticated: isAuthenticated || false },
});

export const setSessionLoadingStatus = isLoading => ({
  type: SET_SESSION_LOADING_STATUS,
  data: { loading: isLoading || false },
});

